// removed by extract-text-webpack-plugin
module.exports = {"content":"basic__content____Fk2d","img":"basic__img___1w_2_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Basic/basic.css
// module id = 154
// module chunks = 0